window.GiftBox = window.GiftBox || {};

import ReactDOM from 'react-dom';
import App from './App';
import Tracker from './utils/tracking';
import { logInfo, logError } from './utils/logging';
import { cloneButtons, cleanupUnpairedButtons } from './dom/buttons';
import cartWatcher from './dom/cart-watcher';
import { deleteCookie } from './utils/cookies';
import { LOCALSTORAGE_KEY } from './utils/tracking';

function initialize() {
  if (window.DISABLE_GIFT_BOX) {
    logInfo('disabled by DISABLE_GIFT_BOX');
    return;
  }
  try {
    logInfo('loaded 🎉');
    const tracker = new Tracker();

    if (window.Shopify.checkout || window.Shopify.Checkout) {
      logInfo(`order status page`);
      window.localStorage.removeItem('giftbox-discount');
      window.localStorage.removeItem(LOCALSTORAGE_KEY);
      deleteCookie('discount_code');
    } else {
      if (document.getElementById('giftbox-root')) {
        logInfo('root is already present.');
        return;
      }
      cleanupUnpairedButtons();
      cloneButtons();
      cartWatcher.setupDefaultObservers();

      document.body.insertAdjacentHTML(
        'beforeend',
        '<div id="giftbox-root"></div>',
      );
      ReactDOM.render(
        <App tracker={tracker} />,
        document.getElementById('giftbox-root'),
      );
    }
  } catch (error) {
    logError(error);
  }
}

if (
  document.readyState === 'complete' ||
  (document.readyState !== 'loading' && !document.documentElement.doScroll)
) {
  initialize();
} else {
  document.addEventListener('DOMContentLoaded', initialize);
}
